import { apiClient } from "./client";
import type { components } from "./schema";

/**
 * Canonical role entry returned by `GET /api/v1/accounts/users/roles/`.
 *
 * The backend is the single source of truth for role labels and ordering.
 * The schema.d.ts generator produces the ``RoleCatalogEntry`` type; we
 * re-export it here so callers don't have to reach into ``components``.
 */
export type RoleCatalogEntry = components["schemas"]["RoleCatalogEntry"];

export const rolesApi = {
  /** Fetch the full role catalog (already sorted highest-level first). */
  catalog: async (): Promise<RoleCatalogEntry[]> => {
    const res = await apiClient.get("/accounts/users/roles/");
    // DRF pagination may wrap it in { results: [...] }; our @action does not
    // paginate but spectacular still generates a Paginated response type.
    return Array.isArray(res.data) ? res.data : (res.data.results ?? []);
  },
};
